import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { vehiclesAPI, customersAPI } from '../../services/api';
import toast from 'react-hot-toast';

const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };

const TYPES = [
  { value:'hatch',  label:'Hatch' },
  { value:'sedan',  label:'Sedan' },
  { value:'suv',    label:'SUV' },
  { value:'pickup', label:'Caminhonete/Pickup' },
  { value:'van',    label:'Van' },
  { value:'truck',  label:'Caminhão' },
  { value:'moto',   label:'Moto' },
  { value:'other',  label:'Outros' },
];

export default function VehicleList() {
  const [vehicles, setVehicles] = useState([]);
  const [meta, setMeta]         = useState({});
  const [search, setSearch]     = useState('');
  const [page, setPage]         = useState(1);
  const [loading, setLoading]   = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({});
  const [editing, setEditing]   = useState(null);
  const [customers, setCustomers] = useState([]);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const r = await vehiclesAPI.list({ search, page, limit: 20 });
      setVehicles(r.data.data); setMeta(r.data.meta);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search, page]);

  useEffect(() => {
    if (showForm) customersAPI.list({ limit: 200 }).then(r => setCustomers(r.data.data || []));
  }, [showForm]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    try {
      const payload = { type: 'hatch', ...form, plate: form.plate?.toUpperCase() };
      if (editing) await vehiclesAPI.update(editing.id, payload);
      else         await vehiclesAPI.create(payload);
      toast.success(editing ? 'Veículo atualizado!' : 'Veículo cadastrado!');
      setShowForm(false); setForm({}); setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const startEdit = (v) => { setEditing(v); setForm(v); setShowForm(true); };

  const del = async (id) => {
    if (!window.confirm('Remover veículo?')) return;
    try { await vehiclesAPI.delete(id); toast.success('Removido.'); load(); }
    catch { toast.error('Erro ao remover.'); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Veículos</h1>
        <button onClick={()=>{setShowForm(true);setForm({type:'hatch'});setEditing(null)}}
          style={{ background:'#2563EB', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer' }}>
          + Novo Veículo
        </button>
      </div>

      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1)}} placeholder="Buscar por placa, modelo ou cliente..."
        style={{ ...inp, marginBottom:16, padding:'10px 16px' }} />

      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #E5E7EB', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:700 }}>
          <thead><tr style={{ background:'#F8FAFC', borderBottom:'1px solid #E5E7EB' }}>
            {['Placa','Modelo','Tipo','Cor','Cliente','Ações'].map(h=>(
              <th key={h} style={{ padding:'12px 16px', textAlign:'left', fontSize:'.8rem', fontWeight:600, color:'#6B7280' }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {loading
              ? <tr><td colSpan={6} style={{ padding:40, textAlign:'center', color:'#9CA3AF' }}>Carregando...</td></tr>
              : vehicles.length === 0
                ? <tr><td colSpan={6} style={{ padding:40, textAlign:'center', color:'#9CA3AF' }}>Nenhum veículo.</td></tr>
                : vehicles.map(v => (
                  <tr key={v.id} style={{ borderBottom:'1px solid #F1F5F9' }}>
                    <td style={{ padding:'12px 16px', fontWeight:700, color:'#2563EB', cursor:'pointer' }} onClick={()=>navigate(`/vehicles/${v.id}`)}>
                      {v.plate}
                    </td>
                    <td style={{ padding:'12px 16px' }}>
                      <div style={{ fontWeight:600 }}>{v.model}</div>
                      <div style={{ fontSize:'.75rem', color:'#9CA3AF' }}>{v.brand} {v.year}</div>
                    </td>
                    <td style={{ padding:'12px 16px', fontSize:'.85rem', textTransform:'capitalize' }}>{v.type}</td>
                    <td style={{ padding:'12px 16px', fontSize:'.85rem' }}>{v.color || '—'}</td>
                    <td style={{ padding:'12px 16px', fontSize:'.85rem', color:'#6B7280' }}>{v.customer_name || '—'}</td>
                    <td style={{ padding:'12px 16px' }}>
                      <button onClick={()=>startEdit(v)} style={{ background:'#EFF6FF', color:'#2563EB', border:'none', borderRadius:6, padding:'4px 12px', cursor:'pointer', marginRight:6, fontSize:'.8rem', fontWeight:600 }}>Editar</button>
                      <button onClick={()=>del(v.id)} style={{ background:'#FEF2F2', color:'#DC2626', border:'none', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontSize:'.8rem', fontWeight:600 }}>Remover</button>
                    </td>
                  </tr>
                ))
            }
          </tbody>
        </table>
      </div>

      {meta.total_pages > 1 && (
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:20 }}>
          {Array.from({ length: meta.total_pages }, (_, i) => i+1).map(p => (
            <button key={p} onClick={()=>setPage(p)}
              style={{ padding:'6px 14px', border:`1.5px solid ${p===page?'#2563EB':'#E5E7EB'}`, borderRadius:6, background:p===page?'#2563EB':'#fff', color:p===page?'#fff':'#374151', cursor:'pointer', fontWeight:p===page?700:400 }}>
              {p}
            </button>
          ))}
        </div>
      )}

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ fontWeight:700, marginBottom:20, color:'#0F172A' }}>{editing?'Editar':'Novo'} Veículo</h3>
            <form onSubmit={save}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={lbl}>Cliente *</label>
                  <select value={form.customer_id||''} onChange={e=>set('customer_id',e.target.value)} required style={inp}>
                    <option value="">Selecione o cliente</option>
                    {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                {[['plate','Placa *','text',true],['model','Modelo *','text',true],['brand','Marca','text',false],['year','Ano','number',false],['color','Cor','text',false]].map(([k,l,t,r]) => (
                  <div key={k}>
                    <label style={lbl}>{l}</label>
                    <input type={t} value={form[k]||''} onChange={e=>set(k,e.target.value)} required={r} style={inp} />
                  </div>
                ))}
                <div>
                  <label style={lbl}>Tipo</label>
                  <select value={form.type||'hatch'} onChange={e=>set('type',e.target.value)} style={inp}>
                    {TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ marginTop:14 }}>
                <label style={lbl}>Observações</label>
                <textarea value={form.notes||''} onChange={e=>set('notes',e.target.value)} rows={2} style={{ ...inp, resize:'vertical' }} />
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
